/** Stripe's documented card brands, as people write them. Anything else is capitalized as Stripe sent it. */
export const CARD_BRAND_LABELS = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
} as const

export type KnownCardBrand = keyof typeof CARD_BRAND_LABELS

export function isKnownCardBrand(brand: string): brand is KnownCardBrand {
  return Object.hasOwn(CARD_BRAND_LABELS, brand)
}

/** `visa` → "Visa", `amex` → "American Express". An unknown brand is capitalized. */
export function cardBrandLabel(brand: string): string {
  if (isKnownCardBrand(brand)) return CARD_BRAND_LABELS[brand]
  return `${brand.charAt(0).toUpperCase()}${brand.slice(1)}`
}
